import axios, { AxiosError } from 'axios';

export function checkIsAxiosError<T = unknown>(error: unknown): error is AxiosError<T> {
    return axios.isAxiosError(error);
}
